<template>
  <div class="col-lg-12">
    <div class="alpha-container">
      <button v-for="letter in alphabet"
              v-text="letter"
              class="alphabet-filter"
              v-on:click="filterByLetter(letter)"
              :class="{selected: letterSelected(letter)}"></button>
    </div>

  </div>
</template>

<script>
export default {
    data() {
      return {
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      };
    },
    props: ['selected'],
    methods: {
      filterByLetter(letter) {
        this.toggleLetter(letter);
        if (!this.selected.length){
          this.$emit('clearAlphaFilter', letter);
          return;
        }
        this.$emit('filterByAlpha', this.selected, 'last_name');
      },

      letterSelected(letter){
        return this.selected.includes(letter);
      },

      toggleLetter(letter){
        if (this.selected.includes(letter)){
          let letter_index = this.selected.indexOf(letter);
          this.selected.splice(letter_index, 1);
        } else {
          this.selected.push(letter);
        }
      }
    }
};
</script>

<style lang="scss">
  @import '../css/_colors.scss';
  @import '../css/constants';
  .alphabet-filter{
    margin: 5px;
    width: 25px;
    height: 25px;
    padding: 0px;
    background-color: $white;
    border-radius: 2px;
    border: 1px solid $gray3;
    color: $gray5;
    font-size: 12px;

    &.selected{
      background-color:$gray6;
    }
  }

  .alpha-container{
    padding:15px;
  }

  .col-lg-12{
    text-align:center;
    border-top: 1px solid $gray4;
    border-bottom:1px solid $gray4;
    background:white;
    margin-left: -$p16;
    margin-right: -$p16;
  }


</style>



// WEBPACK FOOTER //
// src/components/AlphabetizedFilter.vue